console.log('MFR Aisle Form loaded')
class MFRAisleForm {
  constructor(index, element) {
    this.$element = $(element)

		this.selectors = {
      phoneInput: "#aisle-form-input-phoneNumber-field",
      emailInput: "#aisle-form-input-email-field",
      submitButton: ".aisle-form-button",
      consentMessage: ".aisle-form-legal-container",
      errorMessage: ".aisle-form-input-text-error",
      aisleForm: ".aisle-form-wrapper,.page-modal__dialog",
      mailchimpMailForm: ".mailchimp-hidden-form",
    };

		this.config = {
			attributes: true, 
			childList: true, 
			subtree: true
		}

    this.init()
  }

  init() {

		console.log('aisle handler loaded');

		this.$phoneInput = this.$element.find(this.selectors.phoneInput)
		this.$errorMessage = this.$element.find(this.selectors.errorMessage)
		this.$consentMessage = this.$element.find(this.selectors.consentMessage)
		this.$submitButton = this.$element.find(this.selectors.submitButton)
    this.$aisleForm = this.$element.find( this.selectors.aisleForm );
    this.$mailchimpMailForm = this.$element.find(
      this.selectors.mailchimpMailForm
    );

		this.__handleAisleFormDOMMutation()
		this.__handleFormInputReplacePlaceholders()
  }

	__handleAisleFormDOMMutation() {
    let isLoaded = false;
		const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          if (isLoaded) return;
          if (!this.$aisleForm.find(".aisle-form-container").length) return;
          console.log( "Observing Aisle Form...");
          this.$submitButton = this.$aisleForm.find(
            this.selectors.submitButton
          );
		      this.$emailInput = this.$aisleForm.find(this.selectors.emailInput);

          this.$submitButton.on('click', () => {
            const $errors = this.$errorMessage
            const mailchimpFormBTN = this.$mailchimpMailForm.find(
              "form [type='submit']"
            );
						// console.log('submit button click detected');

            if ( $errors.length > 0 ) return

						// console.log('Aisle form submit: success')

						this.$consentMessage.hide()
            if (mailchimpFormBTN.length) {
              console.log(mailchimpFormBTN);
              mailchimpFormBTN.click();
            }

						// fbq('trackCustom', 'SignUp')
						// ttq.track('SignUp')
						// gtag('event', 'SignUp', {
						// 	send_to: 'G-TZNWPWMJY4',
						// 	page_title: 'SMS Sign Up',
						// 	page_path: '/sms-signup',
						// })
						// gtag('event', 'SignUp', { //tracking for nellies
						// 	send_to: 'G-F8JCD6WD69', //unsure if this is correct
						// 	page_title: 'SMS Sign Up',
						// 	page_path: '/sms-signup',
						// })
          })


          this.$emailInput.on( "input", (e) => {
            const emailVal = this.$emailInput.val();
            const mailchimpEmailInput = this.$mailchimpMailForm.find("input[type='email']");
            
            if (mailchimpEmailInput.length) {
              mailchimpEmailInput.val(emailVal);
            }
          } );

          isLoaded = true
        }
      }
    })

    observer.observe(this.$aisleForm.get(0), this.config);
	}

	__handleFormInputReplacePlaceholders() {
		// setTimeout(() => {
		// 	if ( this.$phoneInput.length > 0 ) {
		// 		this.$phoneInput.attr('placeholder', this.$phoneInput.attr('placeholder').replaceAll('.', ''))
		// 	}

		// 	if ( this.$emailInput.length > 0 ) {
		// 		this.$emailInput.attr('placeholder', this.$emailInput.attr('placeholder').replaceAll('.', ''))
		// 	}
		// }, 3000)
	}
}